import { Button, Card, Elevation, FormGroup, HTMLSelect, InputGroup } from "@blueprintjs/core";
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fetch from "node-fetch";
import React, { Fragment } from 'react';
import dateUtils from '../../../utils/date';

class VisitProperty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      location: [],
      locationText: null,
      data: [],
      values: {},
      otp: false,
      complete: false,
      loadToggle: false,
      formError: {
        otp: false,
        city: false,
        societyName: false,
        societyAddress: false,
        contactName: false,
        contactMobile: false,
        name: false,
        mobile: false,
      },
    }
  }

  componentDidMount() {
    this.fetchCities();
  }

  fetchCities() {
    let URL = '/v1/cities?stateUid=mh';
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message === 'Ok') {
          const city = result.data;
          this.setState({
            location: city,
          });
        }
      });
  }

  selectChange = (event) => {
    //now this runs
  }

  handleClick = () => {
    (this.state.values.locationInput ? this.formErrorValueChange("city", false) : this.formErrorValueChange("city", true));
    (this.state.values.societyNameInput ? this.formErrorValueChange("societyName", false) : this.formErrorValueChange("societyName", true));
    (this.state.values.societyAddressInput ? this.formErrorValueChange("societyAddress", false) : this.formErrorValueChange("societyAddress", true));
    (this.state.values.contactNameInput ? this.formErrorValueChange("contactName", false) : this.formErrorValueChange("contactName", true));
    (this.state.values.contactMobileInput ? this.formErrorValueChange("contactMobile", false) : this.formErrorValueChange("contactMobile", true));
    (this.state.values.nameInput ? this.formErrorValueChange("name", false) : this.formErrorValueChange("name", true));
    (this.state.values.mobileInput ? this.formErrorValueChange("mobile", false) : this.formErrorValueChange("mobile", true));

    if (!this.state.formError.city &&
      !this.state.formError.societyName && !this.state.formError.societyAddress &&
      !this.state.formError.contactMobile && !this.state.formError.contactName &&
      !this.state.formError.name && !this.state.formError.mobile) {
      if (this.state.values.mobileInput) {
        let URL = `/v2/send-otp`;
        fetch(URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ mobile: this.state.values.mobileInput, action: "societyLead" })
        })
          .then((response) => {
            return response.json();
          })
          .then((result) => {
            if (result.message !== 'Ok') {
              console.log(result.message);
            }
            this.setState({ otp: true });
          });
      }
    };
  }

  handleClick2 = () => {
    (this.state.values.OTPInput ? this.formErrorValueChange("otp", false) : this.formErrorValueChange("otp", true));
    if (!this.state.formError.otp) {
      this.setState({ loadToggle: true })
    }
    let URL = `/v2/society-lead/create`;
    let data = {
      city: this.state.values.locationInput,
      name: this.state.values.societyNameInput,
      address: this.state.values.societyAddressInput,
      userName: this.state.values.nameInput,
      userMobile: this.state.values.mobileInput,
      contactPersonName: this.state.values.contactNameInput,
      contactPersonMobile: this.state.values.contactMobileInput,
      otp: this.state.values.OTPInput,
    }
    fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(data)
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({ complete: true, loadToggle: false });
        }
      });
  }

  formErrorValueChange = (field, flag) => {
    let errors = this.state.formError;
    errors[field] = flag;
    this.setState({ errors });
  }

  textInputChange = (event) => {
    let values = this.state.values;
    values[event.target.id] = event.target.value;
    this.setState({ values });
  }

  dateInputChange = (value, id) => {
    let values = this.state.values;
    values[id] = dateUtils.dateFormat(value);
    this.setState({ values });
  }

  timeInputChange = (value, id) => {
    let values = this.state.values;
    values[id] = dateUtils.timeFormat(value);
    // this.setState({ values });
  }

  render() {
    return (
      <section className="hero">
        <div className="hero-body">
          <div className="container">
            <div className="content has-text-centered">
              <h1>Society Join Us</h1>
            </div>
            <div className="columns" style={{ marginBottom: '2rem', marginTop: '2rem' }}>
              <div className="column">
                <div className="home-card">
                  <figure className="image is-128x128">
                    <i className="flaticon-money flat-icon" />
                  </figure>
                  <h3>Get Brokerage Revenue Share</h3>
                </div>
              </div>
              <div className="column">
                <div className="home-card">
                  <figure className="image is-128x128">
                    <i className="flaticon-down flat-icon" />
                  </figure>
                  <h3>Reduce Maintainence Cost</h3>
                </div>
              </div>
              <div className="column">
                <div className="home-card">
                  <figure className="image is-128x128">
                    <svg className="icon-svg">
                      <use xlinkHref="#login" />
                    </svg>
                  </figure>
                  <h3>Collaborate Digitally</h3>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="w-420">
              {
                this.state.complete ?
                  <Card className="card" elevation={Elevation.ONE}>
                    <div className="visit-summary content is-size-6">
                      <p className="has-text-success has-text-centered" style={{ marginBottom: "2rem" }}>
                        Congratulations!<br />
                        Your joining request has been accepted successfully.<br />
                        Our representative will contact you soon
                      </p>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Location :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.locationInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Society :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.societyNameInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Address :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.societyAddressInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Contact Person :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.contactNameInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Contact Person Mobile :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.contactMobileInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="">Added By :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.nameInput}</p>
                        </div>
                      </div>
                    </div>
                  </Card>
                  :
                  <Fragment>
                    {
                      this.state.loadToggle ?
                        <div className="has-text-centered has-text-grey-light search-loader">
                          <FontAwesomeIcon icon={faCircleNotch} spin size="4x" />
                        </div> :
                        <div>
                          <Card className="card" elevation={Elevation.ONE}>
                            <FormGroup
                              helperText={this.state.formError.city && "This field is required"}
                              intent="warning"
                            >
                              <HTMLSelect
                                id="locationInput"
                                className="wide-select"
                                fill
                                large
                                required
                                onChange={this.textInputChange}
                                defaultValue={0}
                              >
                                <option value={0} disabled>Select City</option>
                                {this.state.location.map((item, i) => (
                                  <option value={item.name}>{item.name}</option>
                                ))}
                              </HTMLSelect>
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.societyName && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="societyNameInput" placeholder="Society Name" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.societyAddress && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="societyAddressInput" placeholder="Society Address" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.contactName && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="contactNameInput" placeholder="Contact Person Name" type="name" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.contactMobile && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="contactMobileInput" placeholder="Contact Person Mobile" type="number" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.name && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="nameInput" placeholder="Your Name" type="name" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.mobile && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="mobileInput" placeholder="Your Mobile" type="number" />
                            </FormGroup>
                            {
                              this.state.otp &&
                              <Fragment>
                                <hr />
                                <p className="is-size-6">OTP is sent to your mobile number</p>
                                <FormGroup
                                  helperText={this.state.formError.otp && "This field is required"}
                                  intent="warning"
                                >
                                  <InputGroup onChange={this.textInputChange} large id="OTPInput" placeholder="OTP" />
                                </FormGroup>
                              </Fragment>
                            }
                          </Card>
                          <div className="section-thin">
                            {
                              this.state.otp ?
                                <div>
                                  <Button
                                    text="Verify OTP"
                                    onClick={this.handleClick2}
                                    fill
                                    large
                                  />
                                </div>
                                :
                                <div>
                                  <Button
                                    text="Submit"
                                    onClick={this.handleClick}
                                    fill
                                    large
                                  />
                                </div>
                            }
                          </div>
                        </div>
                    }
                  </Fragment>
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default VisitProperty;


// WEBPACK FOOTER //
// ./src/app/components/society-join/index.js